/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * This function imports modules from CDN https://developers.arcgis.com/javascript/latest/programming-patterns/#set-the-portalurl-in-an-amd-application
 * For what is available for import see https://developers.arcgis.com/javascript/latest/api-reference/.
 *
 * @param {string} path - The ArcGIS module path to import (e.g., "esri/Map").
 * @returns {Promise<any>} A promise resolving to the imported module.
 */
export function arcgisImport(path) {
    return globalThis.$arcgis.import(path);
}
